import React, { useEffect } from "react";
import { WizardFormField } from "../machines/immersive-wizard.machine";
import { WizardFormData } from "../types/wizard.types";
import SelectablePills from "../components/SelectablePills";

interface AppointmentPackagesStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const AppointmentPackagesStep: React.FC<AppointmentPackagesStepProps> = ({
  formData,
  onFormUpdate,
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  const appointmentPackageOptions = [
    "Single Session",
    "5-Session Package",
    "10-Session Package",
    "Monthly Unlimited",
    "Personal Training Packages",
    "Consultation Only",
    "Assessment + Follow-up",
    "Intro Package",
    "Specialty Sessions",
    "Group Training Packages",
    "Semi-Private Sessions",
    "Drop-in Sessions",
    "Package + Nutrition",
    "Rehabilitation Packages",
    "Performance Packages",
    "Maintenance Sessions",
  ];

  return (
    <div className="tw-space-y-8">
      <SelectablePills
        title="What types of appointment packages do you offer?"
        options={appointmentPackageOptions.slice(0, 8)}
        selectedOptions={formData[WizardFormField.SelectedAppointmentPackages]}
        onSelectionChange={(selected) => {
          onFormUpdate({
            [WizardFormField.SelectedAppointmentPackages]: selected,
          });
        }}
      />
    </div>
  );
};

export default AppointmentPackagesStep;
